import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

const faqs = [
  {
    q: "How do I get started?",
    a: "Book a free strategy session above. We'll learn your goals, walk you through options, and design a plan with no pressure.",
  },
  {
    q: "Do I need experience to become an agent?",
    a: "No. We provide complete mentorship and licensing guidance. Most of our top performers came in without prior insurance experience.",
  },
  {
    q: "What type of insurance do you offer?",
    a: "Modern life insurance — including IUL, whole life, and term — designed for protection, tax-advantaged cash value growth, and liquidity.",
  },
  {
    q: "Can I work part-time?",
    a: "Yes. Many of our agents start part-time and scale into full-time as their book of business grows. Your schedule is yours.",
  },
  {
    q: "How do consultations work?",
    a: "A licensed strategist meets with you on Zoom or by phone for 15–30 minutes. We focus on clarity, not pitches.",
  },
];

export default function FAQSection() {
  return (
    <section
      data-testid="faq-section"
      className="relative py-24 md:py-40"
    >
      <div className="max-w-4xl mx-auto px-6 md:px-12">
        <div className="reveal text-center">
          <div className="text-[11px] uppercase tracking-[0.28em] text-rolex-light mb-6">
            Frequently Asked
          </div>
          <h2 className="font-serif font-light text-white text-4xl sm:text-5xl lg:text-6xl leading-[1.05] tracking-tight text-balance">
            Questions, <span className="italic text-rolex-light">answered.</span>
          </h2>
        </div>

        <div className="mt-16 reveal">
          <Accordion type="single" collapsible className="space-y-3">
            {faqs.map((f, i) => (
              <AccordionItem
                key={i}
                value={`item-${i}`}
                data-testid={`faq-item-${i}`}
                className="rounded-2xl glass border-white/10 px-6 data-[state=open]:border-rolex/40 transition-colors"
              >
                <AccordionTrigger
                  data-testid={`faq-trigger-${i}`}
                  className="text-left text-white hover:no-underline py-6 font-serif text-xl"
                >
                  {f.q}
                </AccordionTrigger>
                <AccordionContent className="text-gray-400 text-[15px] leading-relaxed font-light pb-6">
                  {f.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </div>
    </section>
  );
}
